module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-navbar', [_c('template', {
    slot: "brand"
  }, [_c('b-navbar-item', {
    attrs: {
      "tag": "router-link",
      "to": {
        path: '/'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "https://raw.githubusercontent.com/buefy/buefy/dev/static/img/buefy-logo.png",
      "alt": "Lightweight UI components for Vue.js based on Bulma"
    }
  })])], 1), _vm._v(" "), _c('template', {
    slot: "start"
  }, [_c('b-navbar-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                Home\n            ")]), _vm._v(" "), _c('b-navbar-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                Documentation\n            ")]), _vm._v(" "), _c('b-navbar-dropdown', {
    attrs: {
      "label": "Info"
    }
  }, [_c('b-navbar-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                    About\n                ")]), _vm._v(" "), _c('b-navbar-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                    Contact\n                ")])], 1)], 1), _vm._v(" "), _c('template', {
    slot: "end"
  }, [_c('b-navbar-item', {
    attrs: {
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('a', {
    staticClass: "button is-primary"
  }, [_c('strong', [_vm._v("Sign up")])]), _vm._v(" "), _c('a', {
    staticClass: "button is-light"
  }, [_vm._v("\n                        Log in\n                    ")])])])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0122dd04"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/navbar/examples/ExSimple.vue
// module id = 1128
// module chunks = 44 209